import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Task from "../../../containers/modules/sales/task";

export default function TaskRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="task"
      index
      element={
        <AccessControl
          name={"Task List"}
          auth={authUser}
          component={() => <Task />}
        />
      }
    />
  );
}
